module.exports = __webpack_public_path__ + "static/img/cern-logo.f51dd63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cern-logo.png
// module id = qrYn
// module chunks = 1